import '../Tabs.scss';
import { CertificationsTabsRelativeRoutes } from 'Routes';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box/Box';
import Tabs from '@trackman/web-shared-components/components/Tabs/Tabs';
import Tab from '@trackman/web-shared-components/components/Tab/Tab';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTabsStore } from 'stores/TabsStore';

export const GetCertified = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useSetPageTitle({
    title: t('MastersAndPartners', { ns: 'general' }),
  });
  const { activeTabIndex } = useTabsStore();

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>{t('MastersAndPartners', { ns: 'general' })}</h1>
        <span className='page-subtitle'>{t('PromoteYourselfAsATrackmanCertified', { ns: 'aboutCertification' })}</span>
      </div>
      <Box className='tabs-container'>
        <Tabs
          scrollButtons='auto'
          value={activeTabIndex}
          variant='scrollable'
          indicatorColor='primary'
          allowScrollButtonsMobile
        >
          <Tab label={t('Partners', { ns: 'aboutCertification' })} onClick={() => navigate(CertificationsTabsRelativeRoutes.Partners)} />
          <Tab label={t('Masters', { ns: 'aboutCertification' })} onClick={() => navigate(CertificationsTabsRelativeRoutes.Masters)} />
          <Tab
            label={t('ApplyForMaster', { ns: 'applyForMaster' })}
            onClick={() => navigate(CertificationsTabsRelativeRoutes.ApplyForMaster)}
          />
        </Tabs>
      </Box>
      <Outlet />
    </>
  );
};

export default GetCertified;
